/*
  sale-1111.js: behaviour for the 11.11 sale page (s1111-* sections).

  - Date copy: "main" (3–10 Nov), "d11" (11 Nov), "d12" (12 Nov), "over"
    (from 13 Nov), SGT. The server renders its own state
    (snippets/s1111-state.liquid, same times); this file re-checks in the
    browser because pages can be served from cache, and switches at
    midnight. ?s1111=main|d11|d12 previews a state. Every element with
    data-s1111-when="…" is shown only in the states it lists.
  - Countdown to Thu 12 Nov 23:59:59 SGT (a fixed instant, rounded down;
    Liquid prints the starting figures, snippets/s1111-left.liquid). Re-run
    as soon as the tab is visible again, as background tabs slow timers.
  - Main deals: Subscribe & save / Buy once toggle and pack choice. The
    total, saving, gift line, button and selling_plan input follow the
    chosen pack's data-* (pre-formatted by Liquid from Shopify).
  - Seal's app embed injects its own subscription widget into product forms
    and deletes selling_plan inputs it didn't add. In s1111 forms its nodes
    are removed and our input is put back before theme.AjaxProduct reads
    the form (capture-phase submit listener).
  - All products: filter tabs.
  - Jump bar: shown after the banner; hidden while the cart drawer is open
    or while an add-to-cart button is in the bottom 80px of the screen.
  Add to cart, tabs, rails and the Klaviyo form are handled by home.js.
*/
(function () {
  'use strict';
  if (window.s1111Loaded) return;
  window.s1111Loaded = true;

  // Unix ms, SGT (+08:00). Keep in step with snippets/s1111-state.liquid.
  var D11 = Date.UTC(2026, 10, 10, 16, 0, 0);       // Wed 11 Nov 00:00
  var D12 = Date.UTC(2026, 10, 11, 16, 0, 0);       // Thu 12 Nov 00:00
  var SALE_END = Date.UTC(2026, 10, 12, 16, 0, 0);  // Fri 13 Nov 00:00
  var CLOCK_END = Date.UTC(2026, 10, 12, 15, 59, 59); // Thu 12 Nov 23:59:59, countdown zero
  var STATES = ['main', 'd11', 'd12', 'over'];

  var forced = null;
  try {
    var q = new URLSearchParams(location.search).get('s1111');
    if (STATES.indexOf(q) > -1) forced = q;
  } catch (e) { /* old browser: no preview override */ }

  function currentState() {
    if (forced) return forced;
    var now = Date.now();
    if (now >= SALE_END) return 'over';
    if (now >= D12) return 'd12';
    if (now >= D11) return 'd11';
    return 'main';
  }

  var state = null;

  function applyState() {
    var next = currentState();
    if (next === state) return;
    state = next;
    document.documentElement.dataset.s1111State = state;
    document.querySelectorAll('[data-s1111-when]').forEach(function (el) {
      el.hidden = el.dataset.s1111When.split(' ').indexOf(state) === -1;
    });
  }

  /* ---------- Countdown ---------- */

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    applyState();
    var clocks = document.querySelectorAll('[data-s1111-clock]');
    if (!clocks.length) return;
    var s = Math.max(0, Math.floor((CLOCK_END - Date.now()) / 1000));
    var parts = { d: String(Math.floor(s / 86400)), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
    clocks.forEach(function (clock) {
      Object.keys(parts).forEach(function (k) {
        var el = clock.querySelector('[data-cd="' + k + '"]');
        if (el && el.textContent !== parts[k]) el.textContent = parts[k];
      });
    });
  }

  /* ---------- Seal guard ---------- */

  var SEAL = '.sealsubs-target-element, .sealsubs-container, [name^="subs_"], input[name="selling_plan"]:not([data-s1111-plan-input])';

  function guardForm(form) {
    if (form.dataset.s1111Guarded) return;
    form.dataset.s1111Guarded = 'true';
    var mine = form.querySelector('[data-s1111-plan-input]');
    var strip = function () {
      form.querySelectorAll(SEAL).forEach(function (el) { el.remove(); });
    };
    var ensure = function () {
      strip();
      if (mine && !mine.isConnected) form.appendChild(mine);
    };
    strip();
    form.addEventListener('submit', ensure, true);
    new MutationObserver(function (records) {
      var touched = records.some(function (r) { return r.addedNodes.length || r.removedNodes.length; });
      if (touched && (form.querySelector(SEAL) || (mine && !mine.isConnected))) ensure();
    }).observe(form, { childList: true, subtree: true });
  }

  /* ---------- Main deals ---------- */

  function updateDeal(panel) {
    var mode = panel.dataset.mode === 'sub' ? 'sub' : 'one';
    var radios = panel.querySelectorAll('input[type="radio"][name="id"]');
    radios.forEach(function (r) {
      r.disabled = r.dataset.available !== 'true' || (mode === 'sub' && !r.dataset.plan);
    });
    var radio = panel.querySelector('input[type="radio"][name="id"]:checked');
    if (!radio || radio.disabled) {
      // Keep the biggest pack the mode allows (3 boxes by default).
      var pick = null;
      radios.forEach(function (r) { if (!r.disabled) pick = r; });
      if (pick) { pick.checked = true; radio = pick; }
    }
    if (!radio) return;

    var d = radio.dataset;
    var sub = mode === 'sub' && !!d.plan;
    var n = Number(d.n) || 1;
    var price = sub ? d.sub : d.one;
    var save = sub ? d.subSave : d.oneSave;
    var pct = sub ? d.subPct : d.onePct;
    var set = function (sel, fn) { panel.querySelectorAll(sel).forEach(fn); };

    panel.querySelectorAll('[data-s1111-mode]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.s1111Mode === mode));
    });
    set('[data-deal-label]', function (el) {
      el.textContent = sub ? 'Each delivery, ' + d.freq : 'Total for ' + n + (n === 1 ? ' box' : ' boxes');
    });
    set('[data-deal-price]', function (el) { el.textContent = price; });
    set('[data-deal-btn]', function (el) { el.textContent = price; });
    set('[data-deal-compare]', function (el) {
      el.hidden = !save;
      el.innerHTML = '<span class="vg-sr">Regular price </span>';
      el.append(d.compare || '');
    });
    set('[data-deal-save]', function (el) {
      el.hidden = !save;
      el.textContent = save ? 'You save ' + save + ' (' + pct + '%)' : '';
    });
    set('[data-gift-n]', function (el) { el.textContent = n; });
    set('.s1111-deal__form [data-home-add]', function (el) { el.disabled = radio.disabled; });

    var input = panel.querySelector('[data-s1111-plan-input]');
    if (input) {
      input.value = sub ? d.plan : '';
      input.disabled = !sub;
    }
  }

  function bindDeals() {
    document.querySelectorAll('[data-s1111-deal]').forEach(function (panel) {
      if (panel.dataset.s1111Bound) return;
      panel.dataset.s1111Bound = 'true';
      panel.addEventListener('change', function (evt) {
        if (evt.target.matches('input[type="radio"][name="id"]')) updateDeal(panel);
      });
      panel.addEventListener('click', function (evt) {
        var b = evt.target.closest('[data-s1111-mode]');
        if (!b) return;
        panel.dataset.mode = b.dataset.s1111Mode;
        updateDeal(panel);
      });
      updateDeal(panel);
    });
  }

  /* ---------- All products filters ---------- */

  function bindFilters() {
    document.querySelectorAll('[data-s1111-filters]').forEach(function (bar) {
      if (bar.dataset.s1111Bound) return;
      bar.dataset.s1111Bound = 'true';
      var section = bar.closest('section');
      var cells = section.querySelectorAll('.s1111-cell');
      var none = section.querySelector('[data-s1111-none]');
      bar.addEventListener('click', function (evt) {
        var btn = evt.target.closest('button[data-f]');
        if (!btn) return;
        var f = btn.dataset.f;
        bar.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        var shown = 0;
        cells.forEach(function (cell) {
          var on = cell.dataset.f.split(' ').indexOf(f) > -1;
          cell.hidden = !on;
          if (on) shown++;
        });
        if (none) none.hidden = shown > 0;
      });
    });
  }

  /* ---------- Jump bar ---------- */

  function bindJump() {
    var bar = document.querySelector('[data-s1111-jump]');
    if (!bar || bar.dataset.s1111Bound) return;
    bar.dataset.s1111Bound = 'true';
    var links = Array.prototype.slice.call(bar.querySelectorAll('a[href^="#"]'));
    links.forEach(function (a) {
      if (!document.getElementById(a.getAttribute('href').slice(1))) a.hidden = true;
    });
    var hero = document.querySelector('[data-s1111-hero]');
    var root = document.documentElement;
    var queued = false;

    function addButtonNearBottom() {
      var limit = window.innerHeight - 80;
      var buttons = document.querySelectorAll('.s1111 [data-home-add], .s1111 .s1111-btn');
      for (var i = 0; i < buttons.length; i++) {
        var b = buttons[i];
        if (b.closest('[data-s1111-jump]') || b.closest('[hidden]')) continue;
        var r = b.getBoundingClientRect();
        if (!r.width) continue;
        if (r.bottom > limit && r.top < window.innerHeight) return true;
      }
      return false;
    }

    function update() {
      queued = false;
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
      var drawer = root.classList.contains('js-drawer-open');
      var show = past && !drawer && !addButtonNearBottom();
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      links.forEach(function (a) { a.tabIndex = show ? 0 : -1; });

      var active = null;
      links.forEach(function (a) {
        var el = document.getElementById(a.getAttribute('href').slice(1));
        if (el && el.getBoundingClientRect().top < 200) active = a;
      });
      links.forEach(function (a) { a.classList.toggle('is-active', a === active); });
    }

    function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(queue).observe(root, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  /* ---------- Init ---------- */

  function init() {
    applyState();
    document.querySelectorAll('.s1111 form.vg-cart-form').forEach(guardForm);
    bindDeals();
    bindFilters();
    bindJump();
    tick();
  }

  init();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') tick();
  });
  document.addEventListener('resume', tick);
  window.addEventListener('pageshow', tick);
  document.addEventListener('shopify:section:load', function () {
    state = null;
    init();
  });
})();
